import { render, staticRenderFns } from "./CardTemplate.vue?vue&type=template&id=5231e0cc"
import script from "./CardTemplate.ts?vue&type=script&lang=ts&external"
export * from "./CardTemplate.ts?vue&type=script&lang=ts&external"
import style0 from "./CardTemplate.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports